var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefits02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M114.928 29.4967C115.538 33.3134 112.94 36.9049 109.124 37.5146C105.307 38.1242 101.715 35.5267 101.106 31.7099C100.496 27.8931 103.094 24.3016 106.91 23.692C110.727 23.0823 114.319 25.6799 114.928 29.4967Z",
    fill: "#F4B3AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M16.6445 82.5001L16.7702 85.1528C16.7866 85.5439 16.6499 85.8749 16.3711 86.1557C16.2399 86.286 16.0759 86.3964 15.8846 86.4766C15.6933 86.5619 15.4855 86.602 15.2505 86.602C14.8077 86.617 14.4359 86.5017 14.1407 86.2459C13.8455 85.9952 13.687 85.6642 13.6706 85.2581L13.5448 82.5803L10.5983 82.6706C10.1555 82.6706 9.79467 82.5502 9.51586 82.3146C9.37373 82.1942 9.25347 82.0388 9.166 81.8582C9.07307 81.6727 9.02385 81.4721 9.01839 81.2515C9.00199 80.8453 9.12774 80.5093 9.39014 80.2486C9.66347 79.9778 10.0352 79.8324 10.4944 79.8173L13.4027 79.7421L13.277 77.0644C13.2606 76.6432 13.3863 76.2921 13.6651 76.0214C13.933 75.7556 14.2828 75.6202 14.7257 75.6052C14.9662 75.5951 15.1903 75.6252 15.3926 75.6954C15.6003 75.7656 15.7753 75.8609 15.9174 75.9812C16.1962 76.2169 16.3493 76.5378 16.3875 76.944L16.5133 79.6469L19.4325 79.5566C19.8753 79.5415 20.2471 79.6619 20.5423 79.9126C20.8375 80.1633 20.996 80.4943 21.0124 80.9005C21.0288 81.1111 21.0015 81.3066 20.9249 81.4872C20.8484 81.6677 20.7445 81.8231 20.6133 81.9535C20.3291 82.2343 19.9737 82.3848 19.5528 82.3998L16.65 82.5001H16.6445Z",
    fill: "#90BCB5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5092 6.62808C91.2529 10.9765 92.9389 25.9409 97.9516 40.2423C102.987 54.5549 111.332 68.2099 108.521 79.2047C105.734 90.2109 91.7791 98.5791 79.9116 97.2754C68.0665 95.983 58.2968 85.041 46.431 78.7651C34.5428 72.4779 20.5531 70.8401 13.3596 62.5813C6.16617 54.3225 5.78064 39.4205 12.7129 30.3531C19.6623 21.2802 33.9294 18.0419 47.9552 13.2918C61.981 8.54163 75.7654 2.27962 83.5092 6.62808Z",
    fill: "#C7DDDA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 74.8513L64.3636 28.7907L51.8454 23.0938L23.3727 33.3968C21.5318 34.1241 20.5499 36.0634 21.2863 38.0028L40.6772 89.7604C41.4136 91.5786 43.3772 92.5483 45.3409 91.821L79.459 79.3362C81.2999 78.7301 82.159 76.7907 81.5454 74.8513Z",
    fill: "#CCCACA",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5591 74.8514L79.4591 26.3666L68.2909 18.4878L38.4682 23.3363C36.5046 23.6999 35.1546 25.5181 35.5228 27.4575L44.7273 81.8817C45.0955 83.8211 46.9364 85.1545 48.9 84.7908L84.8591 78.8514C86.4546 78.609 87.8046 76.7908 87.5591 74.8514Z",
    fill: "#E5E5E5",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9591 75.0939V26.003L83.2636 16.4272H52.95C50.9863 16.4272 49.3909 18.003 49.3909 19.9424V75.0939C49.3909 77.0333 50.9863 78.6091 52.95 78.6091H89.4C91.3636 78.7303 92.9591 77.0333 92.9591 75.0939Z",
    fill: "#F4F4F4",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9591 26.003L83.2637 16.4272V23.2151C83.2637 24.7909 84.6137 26.1242 86.2091 26.1242H92.9591V26.003Z",
    fill: "#BAEAE2",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4545 38.3667H54.7909V46.3667H59.4545V38.3667Z",
    fill: "#FCEBA2",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7818 40.5483H64.1182V46.4877H68.7818V40.5483Z",
    fill: "#90BCB5",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2318 33.7605H73.5681V46.3666H78.2318V33.7605Z",
    fill: "#F6CBA0",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.559 38.3667H82.8954V46.3667H87.559V38.3667Z",
    fill: "#F4B3AE",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3864 34.6089L63.6273 29.0332L66.6954 32.5483L77.1273 24.5483",
    fill: "#F4F4F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3864 34.6089L63.6273 29.0332L66.6954 32.5483L77.1273 24.5483",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6909 23.9424L77.1273 24.5484L76.5136 28.0636",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8909 53.1543V61.1543L57.1227 66.8513C55.65 65.3967 54.7909 63.4573 54.7909 61.1543C54.7909 56.6695 58.35 53.1543 62.8909 53.1543Z",
    fill: "#BAEAE2",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9909 61.1543C70.9909 65.6391 67.309 69.1543 62.8909 69.1543C60.6818 69.1543 58.5954 68.3058 57.1227 66.8513L62.8909 61.1543H70.9909Z",
    fill: "#90BCB5",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9909 61.1543H62.8909V53.1543C67.4318 53.1543 70.9909 56.6695 70.9909 61.1543Z",
    fill: "#FCEBA2",
    stroke: "#313C45",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4091 52.3059H82.0363",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4091 56.6694H87.5591",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4091 61.1543H87.5591",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4091 65.5181H87.5591",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4091 70.0029H87.5591",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits02);
export default __webpack_public_path__ + "static/media/Benefits02.2bb5f53bd5de1543e137b12ac796ebfe.svg";
export { ForwardRef as ReactComponent };